import { useState, useEffect } from "react";

export const useIsMounted = () => {
  const [isMounted, setUseIsMouted] = useState(false);

  useEffect(() => {
    setUseIsMouted(true);
  }, []);

  return isMounted;
};
